import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import usePDPUpSellCart from 'data-hooks/usePDPUpSellCart';
import usePDPAddUpSellProductEvent from 'data-hooks/useEvents/usePDPAddUpSellProductEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useCart from 'data-hooks/useCart';
import PDPUpSellProductUI from './PDPUpSellProductUI';
import usePDPOptions from '../state/context/usePDPOptions';
const PDPUpSellProductInner = t0 => {
  const $ = _c(13);
  const {
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const {
    data: t2,
    actions: t3
  } = useCart();
  const {
    addingToCart
  } = t2;
  const {
    addToCart,
    getCart
  } = t3;
  const {
    data: t4
  } = usePDPUpSellCart();
  const {
    hideUpSell,
    optionPrice,
    priceDetails,
    upSellImgFallbackUrl,
    upSellImgUrl,
    upSellProduct,
    upSellProductLink
  } = t4;
  const {
    data: optionData
  } = usePDPOptions();
  const addUpSellProductEvent = usePDPAddUpSellProductEvent();
  if (hideUpSell) {
    return null;
  }
  let t5;
  if ($[0] !== addToCart || $[1] !== addUpSellProductEvent || $[2] !== addingToCart || $[3] !== getCart || $[4] !== isLayoutRevamp || $[5] !== optionData.selectedOptions || $[6] !== optionPrice || $[7] !== priceDetails || $[8] !== upSellImgFallbackUrl || $[9] !== upSellImgUrl || $[10] !== upSellProduct || $[11] !== upSellProductLink) {
    t5 = <PDPUpSellProductUI addingToCart={addingToCart} addToCart={addToCart} addUpSellProductEvent={addUpSellProductEvent} getCart={getCart} optionPrice={optionPrice} parentProductSelectedOptions={optionData.selectedOptions} priceDetails={priceDetails} upSellImgFallbackUrl={upSellImgFallbackUrl} upSellImgUrl={upSellImgUrl} upSellProduct={upSellProduct} upSellProductLink={upSellProductLink} isLayoutRevamp={isLayoutRevamp} />;
    $[0] = addToCart;
    $[1] = addUpSellProductEvent;
    $[2] = addingToCart;
    $[3] = getCart;
    $[4] = isLayoutRevamp;
    $[5] = optionData.selectedOptions;
    $[6] = optionPrice;
    $[7] = priceDetails;
    $[8] = upSellImgFallbackUrl;
    $[9] = upSellImgUrl;
    $[10] = upSellProduct;
    $[11] = upSellProductLink;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
PDPUpSellProductInner.propTypes = {
  isLayoutRevamp: PropTypes.bool
};
const PDPUpSellProduct = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPUpSellProductInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPUpSellProduct;